import * as React from "react"
import { cn } from "@/lib/utils"

export interface AppleIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 20
   */
  size?: number
}

/**
 * Apple icon as SVG
 *
 * This icon represents Apple sign-in functionality in the ANYW3AR app.
 *
 * @example
 * ```tsx
 * <AppleIcon />
 * <AppleIcon size={24} />
 * ```
 */
export const AppleIcon = React.forwardRef<SVGSVGElement, AppleIconProps>(
  ({ size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 18.5 22.2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path
          d="M13,5.4c.2,0,.4,0,.7,0,.3,0,.7.1,1.1.2.4.1.8.3,1.2.6.4.3.8.7,1.2,1.2,0,0-.2.1-.4.3-.2.2-.5.4-.8.8-.3.3-.6.7-.8,1.2-.2.5-.3,1.1-.3,1.8s.1,1.5.4,2c.3.5.6,1,1,1.3.4.3.7.6,1,.7.3.2.5.2.5.2,0,0,0,.2-.2.5-.1.3-.3.7-.5,1.1-.2.5-.5.9-.8,1.4-.3.4-.6.9-1,1.3-.3.4-.7.7-1.1,1-.4.3-.8.4-1.3.4s-.7,0-.9-.1c-.3,0-.5-.2-.7-.3-.2-.1-.5-.2-.8-.3-.3,0-.6-.1-1-.1s-1,0-1.4.2c-.4.2-.7.3-1,.4-.3.1-.7.2-1.1.2-.7,0-1.3-.3-1.8-.8-.5-.5-1-1.2-1.5-1.9-.4-.6-.8-1.3-1.1-2-.3-.8-.6-1.6-.8-2.4-.2-.9-.3-1.7-.3-2.6,0-1.4.3-2.5.8-3.5.5-.9,1.2-1.6,2-2.1.8-.5,1.7-.7,2.5-.7s.9,0,1.3.2c.4.2.8.3,1.2.5.4.2.7.2,1,.2s.6,0,1-.2c.4-.2.8-.3,1.3-.5.5-.2,1-.2,1.5-.2ZM12.2,3.6c-.4.4-.8.8-1.4,1.1-.5.3-1,.4-1.5.4s-.2,0-.3,0c0,0,0,0,0-.2,0,0,0-.2,0-.2,0-.5.1-1.1.4-1.6.2-.5.5-.9.8-1.3.4-.5.9-.8,1.4-1.1.6-.3,1.1-.5,1.7-.5,0,.1,0,.3,0,.4,0,.6-.1,1.1-.3,1.6-.2.5-.5,1-.8,1.4Z"
          fill="currentColor"
        />
      </svg>
    )
  }
)

AppleIcon.displayName = "AppleIcon"
